import { ErrorMessage, Field, useFormikContext } from 'formik';
import { Dropdown } from 'primereact/dropdown';
import React from 'react';
import { showMessageAlert } from '../others/toastr';
import {
    opPagamento,
    opPagamentoPrime,
    opPagamentoParaES,
    opPagamentoParaESPrime,
    opPagamentoParaESSemBoleto
} from './opcoesDropdown';

export const subGruposValidos = ['ZB', 'ZBC', 'ZFL', 'ZFLC'];

export default function TipoCobranca({ area, estado, setTipoCobrancaSelecionado }) {
    const {
        values: { SubGrupo },
        setFieldValue
    } = useFormikContext();

    let opcoesPagamento = '';

    if (SubGrupo === '') {
        showMessageAlert('SubGrupo Vazio!', 'Favor, selecione um subgrupo!');
    }

    if (subGruposValidos.includes(SubGrupo.trim())) {
        opcoesPagamento = opPagamentoParaESSemBoleto;
    } else {
        opcoesPagamento =
            area !== '3' ?
                estado === 'ES' ?
                    opPagamentoParaES :
                    opPagamento :
                estado === 'ES' ?
                    opPagamentoParaESPrime :
                    opPagamentoPrime;
    }

    const handleChange = e => {
        const selectedValue = e.value;

        setTipoCobrancaSelecionado(selectedValue);
        setFieldValue('AssTipoCobranca', selectedValue);
    };

    return (
        <>
            <Field
                as={Dropdown}
                options={opcoesPagamento}
                placeholder="Tipo Cobranca"
                name="AssTipoCobranca"
                id="AssTipoCobranca"
                onChange={handleChange}
            />
            <ErrorMessage
                component="span"
                name="AssTipoCobranca"
                style={{ color: 'red' }}
            />
        </>
    );
}
